import React from 'react'
import { Glyphicon, Navbar } from 'react-bootstrap'
import { Menu } from 'fw/components'

const classNames = require('classnames');

class Admin extends React.Component {

    constructor(props) {
        super(props);
        this.state = { open: false }
    }

    toggleVisibility = () => {
        this.setState({ open: !this.state.open })
    }

    render() {
        return (
            <div className="navbar-custom-menu AdminMenu">
                <ul className="nav navbar-nav">
                    <li>
                        <Navbar.Collapse>
                            <Menu menuItems={this.props.menuItems.filter((x) => { return x.menuRightSide })} exclude="Admin" />
                        </Navbar.Collapse>
                    </li>
                    <li className={classNames({ dropdown: true, open: this.state.open })} onMouseEnter={this.toggleVisibility}
                        onMouseLeave={this.toggleVisibility}>
                        <a style={{ cursor: "pointer" }}>
                            <Glyphicon glyph="cog" bsSize="large" />
                        </a>
                        <ul role="menu" className="dropdown-menu" aria-labelledby="Admin">
                            <Menu menuItems={this.props.menuItems} parent="Admin" />
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/layouts/main/menu/Admin.js